// extracted by mini-css-extract-plugin
export default {"content":"styles_content__5epSy"};